import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AuthFacadeService } from '@ib-core/services/auth-facade.service';
import { AuthHttpService } from '@ib-core/services/auth-http.service';
import { NavigationService } from '@ib-core/services/navigation.service';
import { MatSnackBarService } from '@ib-core/services/snackbar.service';
import { IB_ROUTES } from '@ib-enums/routes.enum';

@Component({
  selector: 'ib-check-registr-email-link',
  templateUrl: './check-registr-email-link.component.html',
  styleUrls: ['./check-registr-email-link.component.scss'],
})
export class CheckRegistrEmailLinkComponent implements OnInit {
  loading = true;
  error: string;

  get isLoggedIn(): boolean {
    return Boolean(this.authFacadeS.authUser);
  }
  constructor(
    private authHttpS: AuthHttpService,
    private navS: NavigationService,
    private authFacadeS: AuthFacadeService,
    private actRoute: ActivatedRoute,
    private snackbarS: MatSnackBarService,
  ) {}

  ngOnInit(): void {
    const code = this.actRoute.snapshot.params['secureCode'];
    const email = this.actRoute.snapshot.params['email'];
    if (code) {
      this.authHttpS.checkRegistrEmailLink({code,email,}).subscribe({
          next: user => {
            if (user) {
              this.authFacadeS.getMe().subscribe(() => {
                this.navS.goToRoute(IB_ROUTES.DASHBOARD);
              });
            } else {
              this.error = 'Please login to application and resend it again';
            }
            this.loading = false;
          },
          error: err => {
            this.loading = false;
            this.error = this.isLoggedIn
              ? 'Yuo can send it again'
              : 'Please login to application and resend it again';
          },
        });
    }
  }

  logout(): void {
    this.authFacadeS.logout();
  }

  resend(): void {
    this.authHttpS
      .sendRegistrationLink(this.authFacadeS.authUser.email)
      .subscribe({
        next: () => {
          this.loading = false;
          this.snackbarS.show({
            msg: 'Check Your email please',
            type: 'success',
          });
        },
        error: err => {
          this.loading = false;
        },
      });
  }

  toLogin(): void {
    this.navS.goToRoute(IB_ROUTES.LOGIN);
  }
}
